/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../../../../core/components';
import { Component } from '@angular/core';
import { UserService } from '../../../../../../../core/services';

@Component({
    selector: 'app-pipeline',
    templateUrl: './pipeline.component.html',
    styleUrls: ['./pipeline.component.scss']
})
export class PipelineComponent extends BaseComponent {
    /**
     * Page data
     */
    public pageData: any = [];

    /**
     * Store the user's ability to edit
     */
    public userCanEdit: boolean = false;

    public progress = 0;

    /**
     * pipeline ID
     * @private
     */
    private pipelineId;

    constructor(
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
    ) {
        super();

        const id = this.activatedRoute.snapshot.paramMap.get('id');
        if (id) {
            this.pipelineId = id;
        }

        this.setUpUserValues();
        this.setUpPageData();

        this.testProgressBar(0);
    }

    public testProgressBar(progress) {
        setInterval(() => {
            progress++;
            if (progress === 100) {
                progress = 0;
            }

            this.progress = progress;
        }, 50);
    }

    /**
     * Set up user values.
     * @private
     */
    private setUpUserValues(): void {
        const permissions = this.userService.getUser('permissions');
        this.userCanEdit = permissions && (permissions < 4 && permissions !== 0);
    }

    /**
     * Set up page data with API response.
     * @private
     */
    private setUpPageData(): void {
        // api.get(this.pipelineId)
        this.pageData = {
            name: 'Dave\'s pipeline',
            data: [
                {
                    name: 'approved',
                    status: 'pending',
                    cards: [
                        // {
                        //     id: 1727,
                        //     title: 'Update ADC',
                        //     date: '25/09/2000',
                        //     time: '18:00',
                        //     details: 'Update V8.09 to V9.01',
                        //     productLabel: 'GWM PACS 04 Active',
                        //     status: 'update',
                        //     callback: 'done something'
                        // },
                        // {
                        //     id: 1728,
                        //     title: 'Backup ADC',
                        //     date: '26/09/2000',
                        //     time: '18:00',
                        //     details: 'Update V8.09 to V9.01',
                        //     productLabel: 'GWM PACS 04 Active',
                        //     status: 'update',
                        //     callback: 'done something'
                        // }
                    ]
                },
                {
                    name: 'progress',
                    status: 'active',
                    cards: [
                        // {
                        //     id: 2021,
                        //     title: 'Update ADC',
                        //     date: '25/12/0000',
                        //     time: '18:00',
                        //     details: 'Update V8.09 to V9.01',
                        //     productLabel: 'GWM PACS 04 Active',
                        //     progress: 0,
                        //     status: 'updating',
                        //     callback: 'done something'
                        // },
                        // {
                        //     id: 2022,
                        //     title: 'Backup ADC',
                        //     date: '26/09/2000',
                        //     time: '18:00',
                        //     details: 'Update V8.09 to V9.01',
                        //     productLabel: 'GWM PACS 04 Active',
                        //     progress: 0,
                        //     status: 'waiting',
                        //     callback: 'done something'
                        // },
                        // {
                        //     id: 2023,
                        //     title: 'Backup ADC',
                        //     date: '26/09/2000',
                        //     time: '18:00',
                        //     details: 'Update V8.09 to V9.01',
                        //     productLabel: 'GWM PACS 04 Active',
                        //     progress: 0,
                        //     status: 'waiting',
                        //     callback: 'done something'
                        // }
                    ]
                },
                {
                    name: 'completed',
                    status: 'complete',
                    cards: []
                }
            ]
        };
    }
}
